import { render } from "./Kasko.vue?vue&type=template&id=1a748dc9&scoped=true"
import script from "./Kasko.vue?vue&type=script&lang=js"
export * from "./Kasko.vue?vue&type=script&lang=js"

import "./Kasko.vue?vue&type=style&index=0&id=1a748dc9&scoped=true&lang=css"

import exportComponent from "/workspace/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a748dc9"]])

export default __exports__